import Vue from 'vue'
import App from './App'
import router from './router'
import 'vant/lib/index.css';
import 'nprogress/nprogress.css'
import '@/assets/style/init.css'
import './assets/es6/es6-promise.auto.min.js';
import {
  setFontSize,
  installVar,
  globalWH
} from '@/config/index.js'
import NProgress from 'nprogress';
import '@vant/touch-emulator';
import {
  ImagePreview,
  Skeleton,
  NavBar,
  Icon,
  Toast,
  Popup,
  Button
} from 'vant';
Vue.config.productionTip = false
Vue.use(NProgress)
Vue.use(ImagePreview)
Vue.use(Skeleton)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Button)

Vue.use(installVar)
Vue.use(globalWH)



router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  next()
})

new Vue({
  el: '#app',
  router,
  created() {
    //设置rem
    setFontSize(document, window)
  },
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js